import { Button } from "@chakra-ui/react";
import React from "react";
import { FaChevronDown } from "react-icons/fa";
import { IoChevronDown } from "react-icons/io5";

export default function DropDownButton(props: any) {
  return (
    <Button
      w="auto"
      bg="transparent"
      aria-haspopup="listbox"
      rightIcon={<IoChevronDown />}
      justifyContent="space-between"
      mt="2px"
      height="32px"
      maxH="32px"
      px="10px"
      borderRadius="6px"
      variant="outline"
      borderColor="var(--gray)"
      color="var(--white)"
      _hover={{ borderColor: "var(--accent)", bg: "var(--accent-08)" }}
      fontWeight={600}
      fontSize={{
        base: "13px",
      }}
      {...props}
    >
      {props.children}
    </Button>
  );
}
